import Flickity from 'flickity'
import isNull from 'lodash/isNull'

export default class Testimonials {
    constructor() {
        this.cacheDom()
        this.init()
        this.bindEvents()
    }

    cacheDom() {
        this.flkty = null
        this.slider = document.querySelector('.testimonials-inner')
        this.currentSlide = document.querySelector('.testimonials-controls .tagline-alt span')
        this.nextArrow = document.querySelector('.testimonials-controls-next')
        this.prevArrow = document.querySelector('.testimonials-controls-prev')
    }

    init() {
        this.flkty = new Flickity(this.slider, {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            autoPlay: false,
            prevNextButtons: false,
            pageDots: false,
            on: {
                change: (index) => {
                    const sum = index + 1
                    this.currentSlide.innerHTML = sum >= 10 ? sum : `0${sum}`
                },
            },
        })
    }

    bindEvents() {
        if (!isNull(this.flkty) && !isNull(this.nextArrow) && !isNull(this.prevArrow)) {
            this.nextArrow.addEventListener('click', () => {
                this.flkty.next(true, false)
            })

            this.prevArrow.addEventListener('click', () => {
                this.flkty.previous(true, false)
            })
        }
    }
}
